import React from 'react';
import {useSelector} from "react-redux";
import {authNetworkSocialLoginSelected} from "../../../redux/auth/auht-selector";
import ContentModal from "./ContentModal";


const LoginSocialModal = () => {
    const auth_network_social_login = useSelector(authNetworkSocialLoginSelected)

    return (
        auth_network_social_login.modal.isOpen ? <ContentModal/> : null
    );
};

export default LoginSocialModal;